module.exports = __webpack_public_path__ + "img/317.e7ad4425.svg";